import { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from 'forms/rrf';
import IgniteDataTable from '../../common/datatable';
import RequiredInput from '../../common/form/elements/required-input';
import ArrowButton from '../../common/button-arrow';
import { deleteAdminMarketingCategory } from '../../../actions/marketing-category';
import ConfirmPopup from '../../common/confirm-popup';

class MarketingPreferencesTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isShowDeleteConfirmPopup: false,
      id: undefined
    };
  }

  handleDeleteConfirmOnClose = (result) => {
    const { id } = this.state;

    this.setState({
      isShowDeleteConfirmPopup: false,
      id: undefined
    }, () => {
      if (result) {
        const { dispatch } = this.props;

        dispatch(deleteAdminMarketingCategory(id));
      }
    });
  };

  // eslint-disable-next-line class-methods-use-this
  render() {
    const { model, isShowNewCategoryInput, marketingCategories } = this.props;
    const { isShowDeleteConfirmPopup } = this.state;
    const data = [...marketingCategories];

    if (isShowNewCategoryInput) {
      data.unshift({ name_new: ''});
    }

    const columns = [
      {
        prop: 'name',
        title: 'Name',
        width: '80%',
        format(name, row) {
          return (
            <RequiredInput model={`${model}.name_${row.id || 'new'}`}/>
          );
        }
      }
    ];
    const tableActions = [
      (index, row) => (
        // eslint-disable-next-line no-prototype-builtins
        row.hasOwnProperty('name_new') ? (
          <ArrowButton
            arrow={false}
            submit={false}
            onClick={() => {
              const { dispatch, handleRemoveCategoryOnClick } = this.props;

              dispatch(actions.change(`${model}.name_new`, undefined));
              handleRemoveCategoryOnClick();
            }}
          >
            Cancel
          </ArrowButton>
        ) : (
          <ArrowButton
            arrow={false}
            submit={false}
            onClick={() => {
                this.setState({
                  isShowDeleteConfirmPopup: true,
                  id: row.id
                });
              }}
          >
            Delete
          </ArrowButton>
        )
      )
    ];

    return (
      <div>
        <IgniteDataTable
          data={data}
          columns={columns}
          actions={tableActions}
          hasAttributes={false}
        />
        {isShowDeleteConfirmPopup && (
          <ConfirmPopup
            header="Delete Marketing Preference"
            onClose={this.handleDeleteConfirmOnClose}
            confirmLabel="Continue"
          >
            <p>
              Are you sure you want to delete this marketing preference?
            </p>
          </ConfirmPopup>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  marketingCategories: state.marketingCategories.marketingCategories
});

export default connect(mapStateToProps)(MarketingPreferencesTable);
